import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full bg-brand-black my-auto px-4 pb-6 pt-14 z-50" }
const _hoisted_2 = { class: "flex flex-col space-y-6" }
const _hoisted_3 = { class: "flex flex-wrap w-full" }
const _hoisted_4 = { class: "flex flex-col space-y-4" }
const _hoisted_5 = { class: "flex m-auto space-x-2.5" }
const _hoisted_6 = { class: "my-auto pt-0.5" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_checkbox = _resolveComponent("input-checkbox")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex flex-col w-full space-y-2" }, [
                _createElementVNode("div", { class: "flex text-white text-2xl font-medium" }, "What are you looking for?"),
                _createElementVNode("div", { class: "text-brand-light-gray text-lg" }, "Select your desires to connect with like-minded people, the ones that'll really get you. Don't sweat – you can edit these at any time.")
              ], -1)),
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lookingForOptions, (s, sIndex) => {
                  return (_openBlock(), _createBlock(_component_input_checkbox, {
                    class: "mr-2.5 mb-2.5",
                    key: sIndex,
                    name: "lookingFor",
                    modelValue: _ctx.lookingFor,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lookingFor) = $event)),
                    "input-type": "pill",
                    option: s
                  }, null, 8, ["modelValue", "option"]))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_input_checkbox, {
                  name: "display",
                  modelValue: _ctx.showOnProfile,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showOnProfile) = $event)),
                  "input-type": "toggle",
                  option: {
              text: 'Show on my profile',
              value: true
            }
                }, null, 8, ["modelValue"]),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.forward && _ctx.forward(...args))),
                  class: _normalizeClass([{
              'bg-opacity-40' : _ctx.canProgress
            }, "flex w-full bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black transition-all"])
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (!_ctx.busy)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Continue"))
                        : _createCommentVNode("", true),
                      (_ctx.busy)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[4] || (_cache[4] = [
                            _createElementVNode("svg", {
                              class: "animate-spin h-5 w-5 text-brand-black",
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                              }),
                              _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              })
                            ], -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}